import { useQuery } from '@tanstack/react-query';
import type { ArticleAutoConfig } from '@news-cms/shared';
import { Label } from '@/components/ui/label';
import { categoriesListQueryOptions } from '@/lib/taxonomies';

interface Props {
  config: ArticleAutoConfig;
  onChange: (next: ArticleAutoConfig) => void;
}

export function ConfigEditorArticleAuto({ config, onChange }: Props) {
  const categoriesQuery = useQuery(categoriesListQueryOptions());
  const categories = categoriesQuery.data ?? [];

  return (
    <div className="space-y-4">
      <div className="space-y-1.5">
        <Label htmlFor="auto-category">หมวด</Label>
        <select
          id="auto-category"
          value={config.categorySlug ?? ''}
          onChange={(e) => onChange({ ...config, categorySlug: e.target.value || null })}
          className="border-input bg-background h-10 w-full rounded-md border px-3 text-sm"
        >
          <option value="">ทุกหมวด</option>
          {categories.map((c) => (
            <option key={c.id} value={c.slug}>
              {c.name}
            </option>
          ))}
        </select>
        <p className="text-xs text-slate-500">ว่าง = ไม่กรอง — ดึงจากทุกหมวดที่ "published"</p>
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="auto-sort">เรียงตาม</Label>
        <select
          id="auto-sort"
          value={config.sort}
          onChange={(e) => onChange({ ...config, sort: e.target.value as 'latest' | 'popular' })}
          className="border-input bg-background h-10 w-full rounded-md border px-3 text-sm"
        >
          <option value="latest">ล่าสุด</option>
          <option value="popular">ยอดนิยม</option>
        </select>
      </div>
    </div>
  );
}
